/** Knowledge graph console (M28, GR-G3-2): buod, mga item, drawer ng isang item, merge at rebuild. */
export const knowledgeGraph = {
  title: "Knowledge graph",
  subtitle:
    "Ang mga opisina, programa, bayarin at iba pang binabanggit ng mga source mo, at kung paano sila magkakaugnay. Ayusin ang pangalan, pagsamahin ang mga duplicate o itago ang hindi dapat gamitin ng assistant mo.",
  stage: "Experiment",
  loading: "Nilo-load ang knowledge graph",
  error: {
    title: "Hindi ma-load ang knowledge graph",
    body: "Hindi apektado ang mga source at ang mga sagot ng assistant mo. Subukan ulit.",
    retry: "Subukan ulit",
  },
  access: {
    viewOnly:
      "Makikita mo ang graph pero hindi mo ito mababago. Humingi sa owner ng workspace ng pahintulot na mag-edit ng knowledge para makapag-rename, makapagtago, makapagsama o makapagdagdag ng pangalan.",
    rebuildOnly:
      "Puwede kang mag-edit ng mga item pero hindi mo mabubuo ulit ang graph. Humingi sa owner ng workspace ng pahintulot na mag-re-index ng knowledge.",
    support: "Read-only ang support session na ito, kaya walang mababago rito.",
    supportReason: "Read-only sa panahon ng support session",
    needEdit: "Kailangan mo ng pahintulot na mag-edit ng knowledge",
    needRebuild: "Kailangan mo ng pahintulot na mag-re-index ng knowledge",
  },
  off: {
    on: "Naka-on",
    off: "Naka-off",
    layersLabel: "Ang mga layer na nagpapasya kung tatakbo ang graph",
    layers: {
      platform_flag: "Platform rollout",
      plan: "Plan",
      tenant_override: "Switch ng workspace",
      agent: "Setting ng assistant",
    },
    knowledgeCta: "Buksan ang Knowledge Base",
    billingCta: "Tingnan ang mga plan",
    agentCta: "Buksan ang settings ng assistant",
    blockedBy: "Naka-off sa: {{layer}}",
    regionLabel: "Naka-off ang knowledge graph",
    platform_flag: {
      title: "Hindi pa naka-on ang knowledge graph",
      body: "Experiment ito at paunti-unting ibinibigay sa mga workspace. Walang kulang sa panig mo at gumagana pa rin ang mga sagot gaya ng dati. Magtanong sa Sagot team kung gusto mo ng maagang access.",
    },
    plan: {
      title: "Kasama ang knowledge graph sa Pro plan",
      body: "Hindi ito kasama sa kasalukuyan mong plan. Mag-upgrade para masundan ng assistant mo ang ugnayan ng mga opisina, programa at bayarin sa lahat ng source mo. Patuloy na gagana ang mga source at sagot mo gaya ng dati.",
    },
    tenant_override: {
      title: "Naka-off ang knowledge graph sa workspace na ito",
      body: "In-off ito ng isang Sagot administrator para sa workspace na ito, kaya walang binabasa papunta sa graph. Gumagana pa rin ang mga source at sagot mo. Hilingin sa Sagot team na i-on ito ulit.",
    },
    agent: {
      title: "Wala pang assistant na gumagamit ng knowledge graph",
      body: "Pinapayagan ang graph sa workspace na ito pero Off ito sa bawat assistant. Sa Retrieval settings ng assistant, gawing Assist ang knowledge graph; babasahin na ang mga source mo papunta sa graph.",
    },
  },
  noAssistant: {
    body: "Walang assistant na naka-set na gumamit ng graph, kaya hindi naidaragdag ang mga bago o muling binasang source. Nananatili ang mga nandito para ma-review mo.",
    cta: "Buksan ang settings ng assistant",
  },
  empty: {
    regionLabel: "Wala pang graph",
    title: "Wala pang graph",
    body: "Lalaki ang graph habang binabasa ang mga source mo. Magdagdag ng source sa Knowledge Base mo, o basahin ulit ang mga nandiyan na.",
    bodyNoAssistant:
      "Walang mababasa papunta sa graph hangga't walang assistant na naka-set na gumamit nito. I-on ito sa Retrieval settings ng assistant, saka basahin ang mga source mo.",
    filteredTitle: "Walang item na tumutugma",
    filteredBody: "Subukan ang ibang salita, o i-clear ang mga filter para makita ang lahat ng item.",
    nothingVisibleTitle: "Walang nakikitang item",
    nothingVisibleBody: "Nakatago o naisama na sa iba ang bawat item. Ipakita lahat para ma-review ang mga ito.",
  },
  summary: {
    label: "Kabuuan ng knowledge graph",
    items: "Mga item",
    itemsHint: "na magagamit ng assistant mo",
    relations: "Mga ugnayan",
    relationsHint: "sa pagitan ng mga item",
    hidden: "Nakatago",
    hiddenHint: "hindi ginagamit sa mga sagot",
    merged: "Naisama",
    mergedHint: "isinama sa ibang item",
    lastRun: "Huling pagbasa",
    never: "Wala pang nababasa papunta sa graph.",
    run: {
      queued: "Naghihintay magsimula",
      running: "Binabasa ang mga source mo",
      succeeded: "Tapos na",
      failed: "Hindi natapos",
      deferred: "Naka-pause: naubos ang budget",
      deferredSize: "Naka-pause: masyadong malaki ang workspace",
    },
    runValue: "{{chunks}} chunk ang nabasa · {{items}} bagong item · {{relations}} bagong ugnayan",
    runFailed: "Nananatili ang graph mula sa naunang pagbasa. Dahilan: {{reason}}",
    runSizeLimit: "Mas marami ang aktibong chunk ng workspace na ito kaysa sa kayang pagsilbihan ng graph, kaya hindi ito binubuo o muling binubuo. Magtanggal ng mga source para magpatuloy; gumagana pa rin ang graph na mayroon na.",
    cooldown: "Puwede mo ulit itong buuin sa loob ng {{minutes}} min.",
    budget: "Budget sa pagbasa",
    budgetLabel: "Mga chunk na nabasa noong {{month}}",
    budgetValue: "{{used}} sa {{limit}}",
    budgetHint: "Binibilang ang bawat chunk na binabasa papunta sa graph. Nagsisimula ulit ang budget kada buwan (UTC).",
    budgetUsedUp: "Naubos na ang budget ngayong buwan. Maghihintay ang mga source hanggang sa susunod na buwan.",
    budgetNone: "Walang buwanang budget sa pagbasa ang planong ito.",
  },
  filters: {
    search: "Hanapin ang mga item at iba pang pangalan",
    searchLabel: "Hanapin ang mga item",
    type: "I-filter ayon sa uri",
    allTypes: "Lahat ng uri",
    typeOption: "{{type}} ({{count}})",
    sort: "I-sort ang mga item",
    sortOptions: { mentions: "Pinakamadalas banggitin", name: "Pangalan, A hanggang Z", recent: "Kamakailang binago" },
    status: "Ipakita ang mga item",
    statusOptions: { active: "Nakikita", hidden: "Nakatago", merged: "Naisama", all: "Lahat" },
    clear: "I-clear ang mga filter",
    showAll: "Ipakita lahat ng item",
  },
  list: {
    label: "Mga item sa knowledge graph",
    errorTitle: "Hindi ma-load ang mga item",
    hidden: "Nakatago",
    merged: "Naisama",
    decided: "Desisyon mo",
    decidedHint: "Pinananatili kapag binuo ulit ang graph",
    open: "Buksan ang {{name}}",
    names_one: "{{count}} iba pang pangalan",
    names_other: "{{count}} na iba pang pangalan",
    item: "Item",
    type: "Uri",
    mentions: "Mga banggit",
    relations: "Mga ugnayan",
    changed: "Binago",
    mentionsCount_one: "{{count}} banggit",
    mentionsCount_other: "{{count}} na banggit",
    relationsCount_one: "{{count}} ugnayan",
    relationsCount_other: "{{count}} na ugnayan",
    showing: "Ipinapakita ang {{from}} hanggang {{to}} sa {{total}}",
    pages: "Mga pahina ng item",
    previous: "Nakaraang pahina",
    next: "Susunod na pahina",
    page: "Pahina {{n}}",
    pageOf: "Pahina {{page}} sa {{count}}",
  },
  drawer: {
    loading: "Nilo-load ang item",
    description: "{{type}} sa knowledge graph mo",
    notFoundTitle: "Wala sa graph ang item na ito",
    notFoundBody: "Maaaring nabura ito ng rebuild, o luma na ang link.",
    backToList: "Bumalik sa listahan",
    errorTitle: "Hindi ma-load ang item na ito",
    mentions: "Mga banggit",
    relations: "Mga ugnayan",
    names: "Iba pang pangalan",
    firstSeen: "Unang nakita",
    changed: "Huling pagbabago",
    visible: "Nakikita",
    hiddenNote:
      "Nakatago: hindi ginagamit ng assistant mo ang item na ito at hindi na ito gagawin ulit ng graph. Ipakita ulit ito para ma-rename o maisama.",
    decidedNote: "Ikaw ang nagpasya sa item na ito. Pinananatili ng rebuild ang desisyon mo.",
    mergedInto: "Isinama sa “{{name}}”. Nananatili ito rito bilang pointer.",
    mergedNote: "Isinama ang item na ito sa ibang item.",
    openSurvivor: "Buksan ang “{{name}}”",
  },
  actions: {
    rename: "I-rename",
    hide: "Itago",
    show: "Ipakita ulit",
    merge: "Isama sa…",
    hiddenDone: "Nakatago na ang “{{name}}”.",
    shown: "Nakikita na ulit ang “{{name}}”.",
  },
  aliases: {
    title: "Iba pang pangalan",
    hint: "Iba pang baybay na ginagamit ng mga tao para sa item na ito (hanggang {{max}}). Makikita pa rin ito ng tanong na gumagamit ng isa sa mga ito.",
    none: "Wala pang iba pang pangalan.",
    addLabel: "Magdagdag ng iba pang pangalan",
    placeholder: "Halimbawa, maikling anyo",
    language: "Wika",
    languages: { any: "Anumang wika", en: "English", fil: "Filipino", taglish: "Taglish" },
    add: "Idagdag ang pangalan",
    added: "Naidagdag ang “{{alias}}”.",
    remove: "Alisin ang {{alias}}",
    removed: "Naalis ang “{{alias}}”. Hindi na ito idaragdag ulit ng graph.",
  },
  relations: {
    title: "Mga ugnayan",
    hint: "Kung paano nakakonekta ang item na ito sa iba, pinakamalakas muna, kasama ang mga chunk na nagsasabi nito.",
    none: "Wala pang ugnayan.",
    outgoing: "Nakakonekta ang item na ito sa:",
    incoming: "Nakakonekta sa item na ito mula sa:",
    evidence_one: "{{count}} chunk",
    evidence_other: "{{count}} na chunk",
    capped: "Ipinapakita ang unang {{count}} ugnayan.",
  },
  evidence: {
    title: "Saan ito nakasaad",
    hint: "Mga chunk ng mga source mo na bumabanggit sa item na ito o nagsasaad ng isa sa mga ugnayan nito. Mga reference lang ang ipinapakita, hindi ang teksto.",
    none: "Wala pang chunk na tumuturo sa item na ito.",
    mention: "Binabanggit ito",
    relation: "Nagsasaad ng: {{relation}}",
    position: "Chunk {{ordinal}}",
    page: "Pahina {{page}}",
    excluded: "Hindi isinama sa mga sagot",
    capped: "Ipinapakita ang unang {{count}} chunk.",
  },
  names: {
    empty: "Maglagay ng pangalang may kahit isang letra o numero.",
    long: "Gumamit ng {{max}} na character o mas kaunti.",
    chars: "Hindi puwedeng may < > { } [ ] | \\ ` o double quote ang pangalan.",
    same: "Iyan na ang pangalan ng item na ito.",
  },
  rename: {
    title: "I-rename ang “{{name}}”",
    body: "Mananatili ang lumang pangalan bilang iba pang pangalan, kaya makikita pa rin ng tanong na gumagamit nito ang item na ito.",
    label: "Bagong pangalan",
    hint: "Hanggang {{max}} na character. Gumamit ng mga tungkulin, lugar at bagay, hindi ng pangalan ng tao.",
    save: "I-save ang pangalan",
    saved: "Na-rename sa “{{name}}”.",
    openTaken: "Buksan ang item na may ganoong pangalan",
  },
  merge: {
    title: "Isama ang “{{name}}” sa ibang item",
    step: { target: "Piliin ang item na mananatili", review: "Tingnan kung ano ang lilipat", done: "Naisama na" },
    sameType: "Mga nakikitang item lang na magkapareho ng uri ({{type}}) ang puwedeng pagsamahin.",
    search: "Mag-type ng pangalan para paliitin ang listahan",
    searchLabel: "Hanapin ang item na mananatili",
    resultsLabel: "Mga item na puwedeng manatili",
    none: "Walang ibang nakikitang item ng ganitong uri na tumutugma.",
    errorTitle: "Hindi ma-load ang mga item",
    review: "Suriin",
    back: "Bumalik",
    apply: "Pagsamahin ang mga item",
    openTarget: "Buksan ang “{{name}}”",
    reviewIntro: "Isasama ang “{{source}}” sa “{{target}}”. Ito ang lilipat:",
    movesLabel: "Ano ang lilipat",
    moveMentions_one: "{{count}} chunk na bumabanggit sa “{{source}}” ay babanggit na sa “{{target}}”.",
    moveMentions_other: "{{count}} na chunk na bumabanggit sa “{{source}}” ay babanggit na sa “{{target}}”.",
    moveNames_one: "{{count}} iba pang pangalan, at ang “{{source}}” mismo, ay magiging iba pang pangalan ng “{{target}}” (hanggang {{max}}).",
    moveNames_other: "{{count}} na iba pang pangalan, at ang “{{source}}” mismo, ay magiging iba pang pangalan ng “{{target}}” (hanggang {{max}}).",
    moveRelations_one: "{{count}} ugnayan ang lilipat sa “{{target}}”. Pagsasamahin ang kapareho na meron na ito; aalisin ang nasa pagitan ng dalawa.",
    moveRelations_other: "{{count}} na ugnayan ang lilipat sa “{{target}}”. Pagsasamahin ang mga kapareho na meron na ito; aalisin ang mga nasa pagitan ng dalawa.",
    after:
      "Mananatili ang “{{source}}” sa graph bilang pointer sa “{{target}}” (tingnan ang Naisama na filter), kaya walang masisira. Hindi na ito mababawi mula rito, at pinananatili ang desisyon mo kapag binuo ulit ang graph.",
    doneTitle: "Naisama na",
    doneBody: "Bahagi na ng “{{target}}” ang “{{source}}”.",
    doneMentions_one: "{{count}} banggit ang lumipat.",
    doneMentions_other: "{{count}} na banggit ang lumipat.",
    doneNames_one: "{{count}} iba pang pangalan ang lumipat.",
    doneNames_other: "{{count}} na iba pang pangalan ang lumipat.",
    doneRelations: "Mga ugnayan: {{moved}} ang lumipat, {{joined}} ang isinama sa dati nang meron, {{removed}} ang inalis.",
    doneDropped_one: "{{count}} iba pang pangalan ang naiwan dahil puno na ang item.",
    doneDropped_other: "{{count}} na iba pang pangalan ang naiwan dahil puno na ang item.",
  },
  rebuild: {
    action: "Buuin ulit ang graph",
    title: "Buuin ulit ang knowledge graph?",
    body: "Babasahin ulit ang bawat source at papalitan ng mga makikita nito ang mga item mula sa huling pagbasa. Aabutin ito ng ilang minuto at puwede kang magpatuloy sa trabaho.",
    keeps: "Mananatili ang sarili mong mga desisyon: mga rename, nakatagong item, pagsasama at iba pang pangalan.",
    cost: "Gagamit ito ng buwanang budget mo sa pagbasa.",
    costWithBudget: "Gagamit ito ng buwanang budget mo sa pagbasa ({{used}} sa {{limit}} na chunk ang nagamit na).",
    cooldown: "Isang rebuild kada {{minutes}} minuto.",
    confirm: "Buuin ulit",
    queued: "Nagsimula na ang rebuild. Mag-a-update ang mga numero habang tumatakbo ito.",
    waiting: "Puwede mo ulit itong buuin sa loob ng {{minutes}} min",
    noAssistant: "Magtakda muna ng assistant na gagamit ng graph",
  },
  errors: {
    aliasExists: "Meron nang ganoong iba pang pangalan ang item na ito.",
    nameTaken: "May ibang item na ng ganitong uri na may ganoong pangalan.",
    aliasLimit: "Meron nang {{max}} na iba pang pangalan ang item na ito. Mag-alis muna ng isa.",
    entityState: "Nakatago o naisama na ang item na ito, kaya hindi ito mababago sa ganitong paraan. Ipakita muna ito ulit.",
    notFound: "Wala na sa graph ang item na ito. Na-refresh ang listahan.",
    notReady: "Wala pang graph reader sa deployment na ito. Subukan ulit mamaya.",
    disabled: {
      platform_flag: "Na-off ang knowledge graph habang nandito ka. I-reload ang pahina para makita kung bakit.",
      plan: "Hindi kasama sa plan mo ang knowledge graph. I-reload ang pahina para makita kung bakit.",
      tenant_override: "Na-off ang knowledge graph sa workspace na ito. I-reload ang pahina para makita kung bakit.",
      agent: "Magtakda muna ng assistant na gagamit ng knowledge graph, saka subukan ulit.",
    },
    merge: {
      type_mismatch: "Mga item lang na magkapareho ng uri ang puwedeng pagsamahin.",
      not_active: "Mga nakikitang item lang ang puwedeng pagsamahin. Ipakita muna ulit ang dalawang item.",
      self: "Hindi puwedeng isama ang item sa sarili nito.",
    },
    cooldown: "Kakahiling lang ng rebuild. Subukan ulit sa loob ng {{minutes}} min.",
    name: "Maglagay ng pangalang hanggang {{max}} na character.",
  },
} as const;
